import "./productpageaddcomment.css";
import { useTranslation } from '../../hooks/useTranslation';
import { useState } from "react";

// ✅ استخدام متغير البيئة مع قيمة افتراضية للباك إند
const API_URL = process.env.REACT_APP_API_URL;

// ✅ استقبال productId كـ Prop مباشرة من المكون الأب (productpageinfo)
export default function Addcomment({ productId }) {
    const { t } = useTranslation();

    const [commentText, setCommentText] = useState("");
    const [message, setMessage] = useState("");
    const [messageType, setMessageType] = useState(""); // "success" or "error"
    const [isSubmitting, setIsSubmitting] = useState(false);

    // دالة للتحقق من أن النص ليس به كود خبيث
    const isCommentSafe = (text) => {
        const dangerousPatterns = [
            /<script/i,
            /javascript:/i,
            /onerror\s*=/i,
            /onclick\s*=/i,
            /onload\s*=/i,
            /alert\s*\(/i,
            /eval\s*\(/i,
            /document\./i,
            /window\./i,
        ];
        return !dangerousPatterns.some(pattern => pattern.test(text));
    };

    const handleAddComment = async () => {
        // ✅ الآن التحقق سيكون من الـ Prop الممرر بشكل صحيح
        if (!productId) {
            setMessage("خطأ: لم يتم تحديد المنتج.");
            setMessageType("error");
            setTimeout(() => setMessage(""), 3000);
            return;
        }

        const trimmed = commentText.trim();
        if (!trimmed) {
            setMessage("الرجاء كتابة تعليق.");
            setMessageType("error");
            setTimeout(() => setMessage(""), 3000);
            return;
        }

        if (!isCommentSafe(trimmed)) {
            setMessage("نعتذر، التعليق يحتوي على محتوى غير مسموح به.");
            setMessageType("error");
            setTimeout(() => setMessage(""), 3000);
            return;
        }

        // بناء جسم الطلب
        const payload = {
            productId: productId,
            text: trimmed,
        };

        setIsSubmitting(true);

        try {
            // ✅ إرسال الطلب إلى الباك إند الصحيح
            const response = await fetch(`${API_URL}/comments`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });

            if (response.ok) {
                setMessage("✅ تم إضافة تعليقك بنجاح!");
                setMessageType("success");
                setCommentText(""); // تفريغ حقل الكتابة

                // إخفاء رسالة النجاح بعد 3 ثواني
                setTimeout(() => {
                    setMessage("");
                }, 3000);

                // ملاحظة: لتحديث قائمة التعليقات فوراً بدون تحديث الصفحة، 
                // يمكنك لاحقاً إضافة دالة refetch من useProducts هنا، لكن هذا يكفي حالياً.
            } else {
                const errorData = await response.json().catch(() => ({}));
                setMessage(`فشل الإرسال: ${errorData.message || response.statusText}`);
                setMessageType("error");
                setTimeout(() => setMessage(""), 3000);
            }
        } catch (error) {
            setMessage("خطأ في الاتصال بالخادم.");
            setMessageType("error");
            setTimeout(() => setMessage(""), 3000);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="add-comment">
            <div className="add-comment-container">
                <div className="add-comment-input-text">
                    <input
                        type="text"
                        placeholder={t('addCommentPlaceholder') || "أضف تعليقك هنا..."}
                        value={commentText}
                        onChange={(e) => setCommentText(e.target.value)}
                        disabled={isSubmitting}
                        onKeyPress={(e) => {
                            if (e.key === 'Enter') {
                                handleAddComment();
                            }
                        }}
                    />
                </div>
                <div className="add-comment-button">
                    <button
                        onClick={handleAddComment}
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? "جاري الإرسال..." : (t('addComment') || "إضافة تعليق")}
                    </button>
                </div>
            </div>

            {message && (
                <div className={`comment-message ${messageType}`}>
                    {message}
                </div>
            )}
        </div>
    );
}